import Image from "@/atoms-react/image/Image.react.tsx";
import { CardTitle } from "@/atoms-react/text/Text.react.tsx";
import { AnimatedEnvelopePass } from "@/components/animations/envelope-olkypass/index.react.tsx";
import { KYCStatusType } from "@/features/kyc/types.ts";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

type HeaderProps = {
  id?: string | number | null;
  status: string | null;
  lvl3Flow?: boolean;
  custom_scenario?: boolean;
  bannerCreateAccountUrl?: string;
};
export const HeaderIbanModal = ({
  id,
  status,
  lvl3Flow,
  custom_scenario = false,
  bannerCreateAccountUrl
}: HeaderProps) => {
  const { t } = useTranslation(["pass"]);
  const { getLanguage } = usei18n();
  const backgroundStartStep = lvl3Flow
    ? getLanguage() === "fr"
      ? " bg-cover bg-[url('/images/olkypass/lvl3_header_fr.png')]"
      : " bg-cover bg-[url('/images/olkypass/lvl3_header_en.png')]"
    : status === KYCStatusType.DECLARATIVE && !custom_scenario
      ? "bg-slate-50"
      : bannerCreateAccountUrl
        ? "bg-[image:var(--image-url)] bg-cover bg-center bg-no-repeat "
        : "bg-cover bg-[url('/images/olkypass/olkyPayConso.png')]";
  const srcImg =
    getLanguage() === "fr" && !lvl3Flow
      ? "/images/olkypass/status_authenticated.png"
      : "/images/olkypass/status_authenticatedEn.png";
  return (
    <>
      <div
        className={twMerge(
          "mb-6 h-2/5 w-full justify-center overflow-hidden rounded-sm md:h-1/2",
          custom_scenario && "hidden md:flex md:items-center"
        )}
      >
        <div
          style={
            bannerCreateAccountUrl
              ? ({ "--image-url": `url(${bannerCreateAccountUrl})` } as React.CSSProperties)
              : undefined
          }
          className={twMerge(
            "flex h-[200px] w-full items-center justify-center rounded-sm",
            backgroundStartStep
          )}
        >
          {status === KYCStatusType.DECLARATIVE && !custom_scenario ? (
            <AnimatedEnvelopePass srcImg={srcImg} />
          ) : (
            <div
              className={twMerge(
                "flex h-full w-full flex-col items-center justify-center gap-y-3 p-6",
                !lvl3Flow && "bg-blue-800 bg-opacity-30"
              )}
            >
              {!lvl3Flow && !bannerCreateAccountUrl && (
                <Image src="/images/olkypass/olkypay-logo.svg" className="w-24" alt="Olky Logo" />
              )}
              <CardTitle className="text-center text-white">
                {!lvl3Flow && !bannerCreateAccountUrl ? (
                  id ? (
                    t("olkypass.mainPage.olkypass.modalOpenOlkyPay.opening_account_pro")
                  ) : (
                    t("olkypass.mainPage.olkypass.modalOpenOlkyPay.opening_account_conso")
                  )
                ) : (
                  <></>
                )}
              </CardTitle>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
